import React, { useState, useEffect } from 'react';
import { Container, Table, Badge, Button, Spinner } from 'react-bootstrap';
import axios from 'axios';
import { FaShoppingCart, FaTruck, FaCheckCircle } from 'react-icons/fa';
import { Card } from 'react-bootstrap';

const OrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        // In a real app, you would get the user ID from auth context
        const { data } = await axios.get('https://backend.stu89674.webhosting.arden.ac.uk/api/orders?buyer_id=1');
        setOrders(data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching orders:', error);
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  const getStatusBadge = (status) => {
    switch (status.toLowerCase()) {
      case 'pending':
        return <Badge bg="warning" text="dark">Pending</Badge>;
      case 'completed':
        return <Badge bg="success">Completed</Badge>;
      case 'canceled':
        return <Badge bg="danger">Canceled</Badge>;
      default:
        return <Badge bg="secondary">Unknown</Badge>;
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  return (
    <Container className="py-4">
      <h1 className="mb-4">
        <FaShoppingCart className="me-2" />
        My Orders
      </h1>
      
      {orders.length === 0 ? (
        <Card>
          <Card.Body className="text-center py-5">
            <h4>No orders found</h4>
            <p className="text-muted">You haven't placed any orders yet.</p>
            <Button variant="primary">Browse Vehicles</Button>
          </Card.Body>
        </Card>
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Vehicle</th>
              <th>Date</th>
              <th>Status</th>
              <th>Total</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {orders.map(order => (
              <tr key={order.order_id}>
                <td>#{order.order_id}</td>
                <td>
                  {order.make} {order.model} ({order.year})
                </td>
                <td>{new Date(order.order_date).toLocaleDateString()}</td>
                <td>{getStatusBadge(order.status)}</td>
                <td>${order.price?.toLocaleString() || 'N/A'}</td>
                <td>
                  <Button variant="outline-primary" size="sm" className="me-2">
                    View
                  </Button>
                  {order.status === 'Pending' && (
                    <Button variant="outline-danger" size="sm">
                      Cancel
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      <div className="mt-4">
        <Card>
          <Card.Body>
            <h5>
              <FaTruck className="me-2" />
              Shipping Information
            </h5>
            <p className="text-muted">
              Track your shipments and view shipping details for completed orders.
            </p>
            <Button variant="outline-secondary">
              View Shipping Details
            </Button>
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};

export default OrdersPage;